import { createContext } from "react";

export type HeaderContextType = {
  // modalCriacao: boolean;
  // setModalCriacao: (modalCriacao: boolean) => void;
  modalTokensIa: boolean;
  setModalTokensIa: (modalTokensIa: boolean) => void;
  temNotificacaoNova: boolean;
  setTemNotificacaoNova: (temNotificacaoNova: boolean) => void;
  temAulaNova: boolean;
  setTemAulaNova: (temAulaNova: boolean) => void;
  tokensDisponiveis: number | null;
  setTokensDisponiveis: (tokensDisponiveis: number | null) => void;
};

export const HeaderContext = createContext<HeaderContextType>(null!);
